import { Paper, Tabs, Tab, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import Disbursments from '../new-disbursments/disbursments';
import { useDisbursmentsVariant } from '../new-disbursments/hooks/use-disbursments-variant';
import { useTranslation } from 'react-i18next';
import { Header } from './components/header';
import { useParams } from 'react-router-dom';
import { useAccountingUpdateSocketEvent } from "hooks/useAccountingUpdateFromSocket";
import { useQueryClient } from 'react-query';

const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  label: {
    textTransform: "none"
  },
  tabsContainer: {
    '& .Mui-selected': {
      color: "black"
    },
    // Below lg the five tabs share the strip with the order Sidemenu: drop the 160px floor so more labels fit.
    '& .MuiTab-root': {
      [theme.breakpoints.down('lg')]: {
        minWidth: theme.spacing(9),
      },
    },
    '& .MuiTabScrollButton-root': {
      width: theme.spacing(4),
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(3.5),
      },
    },
  }
}));

const AccountingLedger = () => {
  const classes = useStyles();
  const isCompact = useDisbursmentsVariant() === 'card';
  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  const { id: orderId } = useParams<{ id: string }>();
  const queryCache = useQueryClient();
  useAccountingUpdateSocketEvent({
    callback: () => queryCache.invalidateQueries(['accounting-order-disbursments', orderId])
  });
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.container}>
      <Paper>
        <Header />
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={isCompact ? true : 'auto'}
          className={classes.tabsContainer}
        >
          <Tab label={<Typography className={classes.label}>{t('disbursments:ledger')}</Typography>} />
          <Tab label={<Typography className={classes.label}>{t('disbursments:disbursements')}</Typography>} />
          <Tab label={<Typography className={classes.label}>{t('disbursments:receipts')}</Typography>} />
          <Tab label={<Typography className={classes.label}>{t('disbursments:netfunded')}</Typography>} />
          <Tab label={<Typography className={classes.label}>{t('disbursments:proceeds')}</Typography>} />
        </Tabs>
        <div id="add-entry-portal" />
      </Paper>
      <div id="ledger-balance-totals" />

      {value === 0 && <Disbursments kindEntry={['disbursement', 'receipt']} titleTab="ledger" />}
      {value === 1 && <Disbursments kindEntry={['disbursement']} titleTab="disbursements" />}
      {value === 2 && <Disbursments kindEntry={['receipt']} titleTab="receipts" />}
      {value === 3 && <Disbursments kindEntry={['netfunded']} titleTab="netfunded" />}
      {value === 4 && <Disbursments kindEntry={['proceeds']} titleTab="proceeds" />}
    </div>
  );
};

export default AccountingLedger;
